module.exports = __webpack_public_path__ + "img/people-20-min.b0912d9b.png";